import { useT } from '../../hooks/useT';
import styles from './Header.module.css';

function Header({ textKey, level = 'h2', align = 'left' }) {
  const t = useT();
  const Tag = level;

  return (
    <Tag className={styles.header} style={{ textAlign: align }}>
      {t(textKey)}
    </Tag>
  );
}

export default Header;
